module.exports = __webpack_public_path__ + "img/no_change_white_32dp@2x.48d2965c.png";